import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const names = ['Martín', 'Diego', 'Lucas', 'Sebastián', 'Nicolás', 'Federico', 'Matías', 'Joaquín', 'Tomás', 'Agustín', 'Franco', 'Ezequiel'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Neuquén', 'Bahía Blanca'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    // Initial delay
    const initialTimer = setTimeout(() => {
      showRandomBuyer();
    }, 6000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showRandomBuyer = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomCity = cities[Math.floor(Math.random() * cities.length)];
    const randomTime = Math.floor(Math.random() * 59) + 1;
    setCurrentBuyer({
      name: randomName,
      city: randomCity,
      time: randomTime
    });
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next one after 8-12 seconds
      const nextDelay = Math.floor(Math.random() * 4000) + 8000;
      setTimeout(showRandomBuyer, nextDelay);
    }, 5000);
  };
  return <AnimatePresence data-id="element-110">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-zinc-900 border border-zinc-700 shadow-2xl rounded-lg p-4 pr-10 max-w-sm flex items-start gap-3" data-id="element-111">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-zinc-500 hover:text-zinc-300 transition-colors" data-id="element-112">
            <X size={16} data-id="element-113" />
          </button>

          <div className="bg-green-500/20 p-2 rounded-full shrink-0" data-id="element-114">
            <CheckCircle2 className="w-6 h-6 text-green-500" data-id="element-115" />
          </div>

          <div data-id="element-116">
            <p className="text-sm text-zinc-200 font-medium leading-tight mb-1" data-id="element-117">
              <span className="font-bold text-white" data-id="element-118">{currentBuyer.name}</span>{' '}
              de {currentBuyer.city} acaba de comprar el Mega Kit Scooter
            </p>
            <p className="text-xs text-zinc-500" data-id="element-119">
              hace {currentBuyer.time}{' '}
              {currentBuyer.time === 1 ? 'minuto' : 'minutos'}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}